import React from 'react';
import './Industries.css';

const Industries = () => (
  <section id="industries">
    <div className="section-hero">
      <div className="prlx-bg" style={{ backgroundImage: `url('/assets/images/aerosphia-partner-ecosytem-feature-500x500.jpeg')` }}></div>
      <div className="prlx-overlay"></div>
      <div className="prlx-overlay-gold"></div>
      <div className="sh-content">
        <div className="sh-label">Industry Applications</div>
        <h2 className="sh-title">Sectors We <em>Serve</em></h2>
      </div>
    </div>

    <div className="sec industries-sec">
      <div className="sec-inner">
        <div className="centered reveal">
          <div className="sec-label">Industry Applications</div>
          <h2 className="sec-title">Where We Make a <em>Difference</em></h2>
          <div className="divider"></div>
        </div>
        <div className="ind-grid stagger-children">
          <div className="ind-card reveal"><div className="ind-img"><img src="/assets/images/Conv-6-scaled.jpeg" alt="Mining" /></div><div className="ind-body"><div className="ind-ico">⛏️</div><h4>Mining Operations</h4></div></div>
          <div className="ind-card reveal"><div className="ind-img"><img src="/assets/images/audi-factory-floor-shero-2560x1440.jpeg" alt="Handling" /></div><div className="ind-body"><div className="ind-ico">🏭</div><h4>Bulk Materials Handling</h4></div></div>
          <div className="ind-card reveal"><div className="ind-img"><img src="/assets/images/Drawing-106.jpeg" alt="Manufacturing" /></div><div className="ind-body"><div className="ind-ico">🔧</div><h4>Manufacturing Plants</h4></div></div>
        </div>
      </div>
    </div>
  </section>
);

export default Industries;